import { ParamMap } from "utils/param/ParamType"

export const SNAKEMAKE_SLICE_NAME = "Snakemake"

export type SnakemakeType = {
  params: ParamMap
}
